import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import WhatsAppFloat from './components/feature/WhatsAppFloat'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <WhatsAppFloat />
    </BrowserRouter>
  )
}

export default App